module.exports = __webpack_public_path__ + "static/media/noAccessBackground.35269617.svg";